import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";

const report = new AxiosInterceptor();

export default {
  getSubsSummary(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return report.get("/report/subscription-summary?" + qstr);
  },
  getPackageSummary(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return report.get("/report/package-summary?" + qstr);
  },
  getOrderSummary(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return report.get("/report/order-summary?" + qstr);
  },
  getStockSummary(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return report.get("/report/stock-summary?" + qstr);
  },
  getStockReport(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return report.get("/report/stock?" + qstr);
  },
  calcStockReport(data) {
    return report.post("/report/stock/calculate", data);
  },
  checkStockCalculate() {
    return report.get("/report/stock/check");
  }
};
